<template>
  <tr @click="selected($props.data)" :class="{ selected: $props.data.selected }">
    <td v-if="showTagColumn" nowrap>{{ $props.data.tag }}</td>
    <td nowrap>{{ $props.data.number_text }}</td>
    <td nowrap>{{ $props.data.date }}</td>
    <td nowrap>{{ $props.data.technician }}</td>
    <td nowrap>{{ $props.data.department }}</td>
    <td nowrap>{{ quantity }}</td>
  </tr>
</template>

<script>
import { ref, watch, onMounted, toRaw } from "vue";
import _sumBy from "lodash/sumBy";

export default {
  name: "OrderApproved",
  props: {
    data: {
      type: Object,
      required: true,
    },
    showTagColumn: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'selected'
  ],
  setup(props, { emit }) {
    const quantity = ref(0);
    const selected = (orderSelected) => {
      emit("selected", orderSelected);
    };

    onMounted(() => {
      getQuantity();
    });

    watch(() => props.data.articles.length, () => {
        getQuantity();
      }, { deep: true }
    );

    const getQuantity = () => {
      quantity.value = _sumBy(toRaw(props.data.articles), 'approved_quantity');
    };

    return {
      selected,
      quantity,
    };
  },
};
</script>

<style scoped>
tr td {
  text-align: center;
  padding: 0.5em;
  border: 0;
  text-transform: uppercase;
}
.selected {
  background-color: #74C686;
  border: 3px solid #218838;
}
tr:hover {
  cursor: pointer;
}
</style>
